<template>
    <div>
        <Table :columns="schedule.columns" :data="schedule.data">
            <template slot-scope="{ row, index }" slot="timeList">
                <template v-if="row.timeList && row.timeList.length > 0">
                    <div v-for="item in row.timeList" :key="item.id">
                        {{$xmutils.parseWeekDay(item.weekday)}} {{item.start}} - {{item.end}}
                    </div>
                </template>
            </template>
            <template slot-scope="{ row, index }" slot="action">
                <Button @click="scheduleClassRecordList(row)" type="info" size="small" style="margin-right: 5px">详细</Button>
            </template>
        </Table>
        <scheduleClassRecord ref="scheduleClassRecord" :clazzId="clazzId" ></scheduleClassRecord>
    </div>
</template>

<script>
  import scheduleClassRecord from './scheduleClassRecord'

  export default {
    name: 'clazz_schedule',
    props: {
      detailForm: Object,
      clazzId: Number
    },
    components: {
      scheduleClassRecord
    },
    data() {
      return {
        schedule:{
          columns:[
            {
              title:'教师',
              key:'teacher',
              align:'center'
            },
            {
              title:'日期',
              key:'date',
              align:'center'
            },
            {
              title:'剩余排课数',
              key:'remainnum',
              align:'center'
            },
            {
              title:'时间',
              slot:'timeList',
              align:'center'
            },
            {
              title:'操作',
              slot:'action'
            }
          ],
          data:[]
        },
        showScheduleClassRecordModal:false,
        scheduleClassRecordColumns:[
          {
            title:'班级',
            key:'className',
            align:'center'
          },
          {
            title:'日期',
            key:'date',
            align:'center'
          },
          {
            title:'时间',
            key:'time',
            align:'center'
          },
          {
            title:'状态',
            align:'center',
            slot:'state'
          }
        ],
        scheduleClassRecordData:[],
      }
    },
    methods: {
      getSchedules: function () {
        this.$api.clazz.getScheduleList({id: this.clazzId}).then(res => {
          if (res.state == "ok") {
            this.schedule.data = res.data;
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      scheduleClassRecordList:function(row){
        this.$refs.scheduleClassRecord.showModal(row.id)
      },
    },
    filters:{
    },
  }
</script>
